import { useMutation } from "@tanstack/react-query";
import { updateBrandingAndColors } from "api/siteSettings/brandingAndColors";
import { useGetFeatureModuleSetting } from "api/siteSettings/modularApi";
import { queryClient } from "client";
import { ApiResponseType, NotificationType } from "enums";
import { FeatureModules } from "enums/modules";
import { isEmpty, parse, useSearch, useUtilities } from "helpers";
import { t } from "i18next";
import { useEffect } from "react";
import {
  setBrandingAndColors,
  updateBrandingAndColorsAction,
} from "redux/reducers/siteSettings/brandingAndColors";

export function useBrandingAndColors() {
  const { data, isLoading, error, isRefetching } = useGetFeatureModuleSetting(
    FeatureModules.BRANDS_AND_COLORING
  );
  const {
    dispatch,
    brandingAndColors: { brandingAndColors, loaded },
  } = useUtilities();

  useEffect(() => {
    if (
      data &&
      (!loaded || isEmpty(brandingAndColors) || !brandingAndColors) &&
      !isRefetching &&
      !isLoading
    ) {
      dispatch(
        setBrandingAndColors({
          brandingAndColors: {
            ...data.data[0],
            brand_colors_settings: parse(
              data.data[0]?.brand_colors_settings ?? "{}"
            ),
          },
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, isLoading, isRefetching, error, loaded, brandingAndColors]);

  return {
    data: brandingAndColors,
    isLoading: isLoading || !loaded || isRefetching,
    error,
  };
}

export function useUpdateBrandingAndColors() {
  const { web = null } = useSearch();
  const { notification, dispatch } = useUtilities();
  return useMutation(
    (params) =>
      updateBrandingAndColors({
        api_key: localStorage.getItem("apikey"),
        added_by: localStorage.getItem("user_id"),
        website_id: web,
        system_status: 0,
        tab_hint: FeatureModules.BRANDS_AND_COLORING,
        ...params,
      }),
    {
      onSuccess: (data) => {
        if (data.status_code === ApiResponseType.SUCCESS) {
          dispatch(
            updateBrandingAndColorsAction({
              brandingAndColors: data.data,
              website_id: web,
            })
          );
          notification({
            type: NotificationType.SUCCESS,
            message: t(
              "siteSetting.brandingAndColors.api.notification.updated"
            ),
          });
          queryClient.invalidateQueries(["workspaces"]);
          queryClient.invalidateQueries([FeatureModules.BRANDS_AND_COLORING]);
        } else {
          notification({
            type: NotificationType.ERROR,
            message: t(
              "siteSetting.brandingAndColors.api.notification.updateFailed"
            ),
          });
        }
      },
      onError: (error) => {
        notification({
          type: NotificationType.ERROR,
          message:
            error?.response?.data?.message ||
            t("siteSetting.brandingAndColors.api.notification.updateFailed"),
        });
      },
    }
  );
}
